// extracted by mini-css-extract-plugin
export default {"wrapper":"adminCounter_wrapper__XW7Bx","counterContainer":"adminCounter_counterContainer__nTInU"};